<template>
	<div
		id="export-template-modal"
		class="modal fade"
	>
		<div
			class="modal-dialog"
			@keydown.esc="CloseModal"
		>
			<div class="modal-content">
				<GridLayout class="full p-0">
					<template #left-header>
						<Title value="FILTROS" />
					</template>
					<template #left-content>
						<Filters ref="filters" />
					</template>
					<template #left-footer>
						<div
							class="w-full h-full flex justify-center items-center"
						>
							<button
								class="btn btn-fixed-size"
								tabindex="5"
								@click="ClearFilters"
							>
								LIMPAR
							</button>
						</div>
					</template>
					<template #right-header>
						<div class="w-full flex justify-between items-center">
							<Title value="EXPORTAR TEMPLATE" />
							<div class="close-modal-container">
								<button
									id="close-modal"
									class="btn btn-light btn-sm m-2 btn-legacy"
									@click="CloseModal"
								>
									<i class="fal fa-times"></i>
								</button>
							</div>
						</div>
					</template>
					<template #right-content>
						<div
							class="w-full flex-1 flex flex-col items-center main-content m-h-i"
						>
							<template v-if="data_movements?.length === 0">
								<div
									class="mh-200 text-muted d-flex justify-content-center align-items-center"
								>
									<span>Não há nenhum arquivo aqui</span>
								</div>
							</template>
							<template v-else>
								<NewDatatable
									:value="data_movements"
									:headers="headers"
									:showTotal="false"
									:trButton="false"
									:fixedHeader="true"
								>
									<template #row="{ item }">
										<div class="datatable-cell">
											EXPORTAÇÃO #{{ item.id }}
										</div>
										<div class="datatable-cell">
											{{ ParseDate(item.created_at) }}
										</div>
										<div class="datatable-cell">
											{{ ParseTime(item.created_at) }}
										</div>
										<div class="datatable-cell">
											<a
												v-if="
													item.url &&
													!item.in_progress
												"
												class="px-1"
												v-tippy="{
													arrow: true,
												}"
												content="Fazer download"
												@click="DownloadFile(item.url)"
											>
												<i class="fa fa-download"></i>
											</a>
											<span
												v-tippy="{
													arrow: true,
												}"
												content="Arquivo na fila de processamento"
												v-else-if="
													item.status == 'queued'
												"
											>
												<i class="fas fa-clock"></i>
											</span>
											<span
												v-tippy="{
													arrow: true,
												}"
												:content="
													'Gerando arquivo: ' +
													(item.progress_percentage >
													100
														? 99
														: item.progress_percentage) +
													'%'
												"
												v-else-if="
													item.status == 'executing'
												"
											>
												<span
													class="spinner-border spinner-border-sm mt-2"
													role="status"
													aria-hidden="true"
												></span>
											</span>
											<span
												v-tippy="{
													arrow: true,
												}"
												content="Houve uma falhar ao gerar o arquivo..."
												v-else-if="
													item.status == 'failed' ||
													item.status == 'retrying' ||
													(item.status ==
														'finished' &&
														!item.url)
												"
											>
												<i
													class="fas fa-exclamation-circle text-danger pl-1"
												></i>
											</span>
										</div>
									</template>
								</NewDatatable>
							</template>
						</div>
					</template>
					<template #right-footer>
						<div
							class="w-full h-full flex justify-end items-center"
						>
							<button
								class="btn btn-success btn-fixed-size"
								tabindex="6"
								@click="Export"
							>
								EXPORTAR
							</button>
						</div>
					</template>
				</GridLayout>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import axios from 'axios'
	import { mapActions } from 'vuex'
	import Filters from './Filters.vue'
	import Datatables from '@/components/journey_cases/components/Datatables'
	import { useGetSelectedsRecursively } from '@/composables'

	export default {
		name: 'ExportTemplateModal',
		components: {
			Filters,
			Datatables,
		},
		props: {
			data_movements: {
				type: Array,
				required: true,
			},
		},
		data() {
			return {
				headers: [
					{ text: 'NOME', value: 'id' },
					{ text: 'DATA', value: 'created_at.date' },
					{ text: 'HORA', value: 'created_at.time' },
					{ text: 'AÇÕES', value: '' },
				],
			}
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			OpenModal() {
				window.jQuery('#export-template-modal').modal('show')

				window.jQuery('body').addClass('modal-open')

				window.jQuery('#export-template-modal').addClass('d-flex')
			},
			CloseModal() {
				window
					.jQuery('#export-template-modal')
					.modal('hide')
					.on('hidden.bs.modal', () => {
						window.jQuery('body').removeClass('modal-open')

						window
							.jQuery('#export-template-modal')
							.removeClass('d-flex')

						this.$emit('close')
					})
			},
			ClearFilters() {
				this.$refs.filters.ClearFilters()
			},
			async Export() {
				const { modules, modalities } =
					await useGetSelectedsRecursively(
						this.$refs.filters.filters.modules
					)

				this.$emit('export', {
					classes: this.$refs.filters.objectClasses,
					modules,
					modalities,
				})
			},
			ParseDate(timestamp) {
				return moment(timestamp).format('DD/MM/YYYY')
			},
			ParseTime(timestamp) {
				return moment(timestamp).format('HH:mm')
			},
			HasPendingProgress(template) {
				let pendings = template.data_movements.filter(
					e => e.status == 'queued' || e.status == 'executing'
				)

				return pendings.length > 0
			},
			DownloadFile(url) {
				const method = 'GET'

				this.StartLoading()

				axios
					.request({
						url,
						method,
						responseType: 'blob',
					})
					.then(({ data }) => {
						const downloadUrl = window.URL.createObjectURL(
							new Blob([data], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							})
						)
						const link = document.createElement('a')
						link.href = downloadUrl
						// let filename = (split(url, '/')[6] + '.xlsx')
						link.setAttribute('download', '')
						document.body.appendChild(link)
						link.click()
						link.remove()
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
		mounted() {
			this.OpenModal()
		},
	}
</script>

<style lang="scss" scoped>
	#export-template-modal {
		.modal-dialog {
			width: 100vw;
			height: 100vh;
			margin: 0;

			.modal-content {
				width: 100vw;
				height: 100vh;
				display: flex;
				flex-direction: column;
				align-items: center;

				.modal-header,
				.modal-footer {
					height: 4rem;
				}

				.modal-footer {
					padding: 0;
				}
			}
		}
	}

	.m-h-i {
		max-height: inherit;
	}
</style>
